// extracted by mini-css-extract-plugin
export var backButton = "_p-1";
export var content = "_p-d";
export var continueButton = "_p-7";
export var continueHint = "_p-8";
export var continueRow = "_p-6";
export var leftInner = "_p-0";
export var shell = "_p-e";
export var sidebarContent = "_p-5";
export var skipButton = "_p-c";
export var spacer = "_p-2";
export var spin = "_p-a";
export var spinner = "_p-9";
export var spinnerOverlay = "_p-b";
export var subtitle = "_p-4";
export var title = "_p-3";